import type { MetaFunction } from 'react-router'
import { STATIC_PAGE_HEADERS } from "~/lib/cache.server"
import { Navbar } from '~/components/navbar'
import { Footer } from '~/components/footer'

export function headers() { return STATIC_PAGE_HEADERS }

export const meta: MetaFunction = () => [
  { title: 'Politique de confidentialité — AfficheServices' },
  { name: 'description', content: 'Politique de confidentialité et de protection des données personnelles d\'AfficheServices, conforme au RGPD.' },
  { tagName: 'link', rel: 'canonical', href: 'https://www.afficheservices.fr/confidentialité' },
]

export default function Confidentialite() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <div className="mx-auto max-w-3xl px-4 py-16 lg:px-6">
        <h1 className="text-3xl font-bold text-slate-900">Politique de confidentialité</h1>
        <p className="mt-3 text-sm text-slate-600 leading-relaxed">
          Dernière mise à jour : Mars 2026
        </p>
        <p className="mt-3 text-sm text-slate-600 leading-relaxed">
          AfficheServices SAS (ci-après « AfficheServices ») s'engage à protéger la vie privée de
          ses utilisateurs. La présente politique de confidentialité décrit les modalités de
          collecte, de traitement et de protection de vos données personnelles conformément au
          Règlement Général sur la Protection des Données (RGPD — Règlement UE 2016/679) et à l'
          loi Informatique et Libertés du 6 janvier 1978 modifiée.
        </p>

        {/* Responsable du traitement */}
        <div className="mt-10 border-t border-slate-100 pt-10">
          <h2 className="text-xl font-semibold text-slate-900">1. Responsable du traitement</h2>
          <div className="mt-3 text-sm text-slate-600 leading-relaxed space-y-1">
            <p>Le responsable du traitement des données personnelles est :</p>
            <p className="mt-3"><strong className="text-slate-900">AfficheServices SAS</strong></p>
            <p>Siège social : Paris, France</p>
            <p>Email : contact@afficheservices.fr</p>
            <p>Délégué à la protection des données (DPO) : dpo@afficheservices.fr</p>
          </div>
        </div>

        {/* Données collectées */}
        <div className="mt-10 border-t border-slate-100 pt-10">
          <h2 className="text-xl font-semibold text-slate-900">2. Données collectées</h2>
          <p className="mt-3 text-sm text-slate-600 leading-relaxed">
            Nous collectons les catégories de données personnelles suivantes :
          </p>
          <h3 className="mt-6 text-lg font-medium text-slate-900 mb-2">
            2.1 Données d'identification
          </h3>
          <p className="mt-3 text-sm text-slate-600 leading-relaxed">
            Nom, prénom, adresse email, numéro de téléphone, adresse postale, mot de passe
            (chiffre).
          </p>
          <h3 className="mt-6 text-lg font-medium text-slate-900 mb-2">
            2.2 Données relatives aux projets
          </h3>
          <p className="mt-3 text-sm text-slate-600 leading-relaxed">
            Description du projet, type de travaux, localisation du chantier, budget estimatif,
            photos du projet.
          </p>
          <h3 className="mt-6 text-lg font-medium text-slate-900 mb-2">
            2.3 Données professionnelles (artisans)
          </h3>
          <p className="mt-3 text-sm text-slate-600 leading-relaxed">
            Raison sociale, numéro SIRET, attestation d'assurance, qualifications professionnelles,
            zone d'intervention, portfolio de réalisations.
          </p>
          <h3 className="mt-6 text-lg font-medium text-slate-900 mb-2">
            2.4 Données de navigation
          </h3>
          <p className="mt-3 text-sm text-slate-600 leading-relaxed">
            Adresse IP, type de navigateur, pages visitées, durée des visites, données de cookies.
          </p>
        </div>

        {/* Finalités */}
        <div className="mt-10 border-t border-slate-100 pt-10">
          <h2 className="text-xl font-semibold text-slate-900">3. Finalités du traitement</h2>
          <p className="mt-3 text-sm text-slate-600 leading-relaxed">
            Vos données personnelles sont collectées et traitées pour les finalités suivantes :
          </p>
          <ul className="mt-3 space-y-2 text-sm text-slate-600 leading-relaxed list-disc pl-5">
            <li>Gestion de votre compte utilisateur et authentification</li>
            <li>Mise en relation entre particuliers et professionnels du bâtiment</li>
            <li>Traitement et suivi des demandes de devis</li>
            <li>Vérification des qualifications et assurances des professionnels</li>
            <li>Communication relative à vos projets et aux services de la plateforme</li>
            <li>Amélioration de nos services et de l'expérience utilisateur</li>
            <li>Envoi de newsletters et communications commerciales (avec votre consentement)</li>
            <li>Prevention des fraudes et sécurité de la plateforme</li>
            <li>Respect de nos obligations légales et réglementaires</li>
          </ul>
        </div>

        {/* Base légale */}
        <div className="mt-10 border-t border-slate-100 pt-10">
          <h2 className="text-xl font-semibold text-slate-900">4. Base légale du traitement</h2>
          <p className="mt-3 text-sm text-slate-600 leading-relaxed">
            Le traitement de vos données repose sur les bases légales suivantes :
          </p>
          <ul className="mt-3 space-y-2 text-sm text-slate-600 leading-relaxed list-disc pl-5">
            <li>
              <strong className="text-slate-900">Exécution du contrat :</strong> le traitement est
              nécessaire à l'exécution de nos services (mise en relation, gestion des devis)
            </li>
            <li>
              <strong className="text-slate-900">Consentement :</strong> pour l'envoi de
              communications commerciales et le dépôt de cookies non essentiels
            </li>
            <li>
              <strong className="text-slate-900">Intérêt légitime :</strong> pour l'amélioration de
              nos services, la prévention des fraudes et la sécurité de la plateforme
            </li>
            <li>
              <strong className="text-slate-900">Obligation légale :</strong> pour le respect de nos
              obligations fiscales et comptables
            </li>
          </ul>
        </div>

        {/* Durée de conservation */}
        <div className="mt-10 border-t border-slate-100 pt-10">
          <h2 className="text-xl font-semibold text-slate-900">5. Durée de conservation</h2>
          <p className="mt-3 text-sm text-slate-600 leading-relaxed">
            Vos données personnelles sont conservées pendant les durées suivantes :
          </p>
          <ul className="mt-3 space-y-2 text-sm text-slate-600 leading-relaxed list-disc pl-5">
            <li>
              <strong className="text-slate-900">Données de compte :</strong> pendant toute la durée
              de votre inscription, puis 3 ans après la dernière activité sur votre compte
            </li>
            <li>
              <strong className="text-slate-900">Données de projet :</strong> 3 ans après la
              clôture du projet
            </li>
            <li>
              <strong className="text-slate-900">Données de facturation :</strong> 10 ans
              conformément aux obligations comptables
            </li>
            <li>
              <strong className="text-slate-900">Données de navigation :</strong> 13 mois maximum
              conformément aux recommandations de la CNIL
            </li>
          </ul>
        </div>

        {/* Destinataires */}
        <div className="mt-10 border-t border-slate-100 pt-10">
          <h2 className="text-xl font-semibold text-slate-900">6. Destinataires des données</h2>
          <p className="mt-3 text-sm text-slate-600 leading-relaxed">
            Vos données personnelles peuvent être communiquées aux destinataires suivants :
          </p>
          <ul className="mt-3 space-y-2 text-sm text-slate-600 leading-relaxed list-disc pl-5">
            <li>Les professionnels du bâtiment inscrits sur la plateforme, dans le cadre de la mise en relation</li>
            <li>Nos sous-traitants techniques (hébergement, envoi d'emails, paiement en ligne)</li>
            <li>Les autorités administratives ou judiciaires, lorsque la loi l'exige</li>
          </ul>
          <p className="mt-3 text-sm text-slate-600 leading-relaxed">
            Nous ne vendons jamais vos données personnelles à des tiers. Nos sous-traitants sont
            liés par des clauses contractuelles garantissant la sécurité et la confidentialité de
            vos données.
          </p>
        </div>

        {/* Droits des utilisateurs */}
        <div className="mt-10 border-t border-slate-100 pt-10">
          <h2 className="text-xl font-semibold text-slate-900">7. Vos droits</h2>
          <p className="mt-3 text-sm text-slate-600 leading-relaxed">
            Conformément au RGPD, vous disposez des droits suivants sur vos données personnelles :
          </p>
          <ul className="mt-3 space-y-2 text-sm text-slate-600 leading-relaxed list-disc pl-5">
            <li>
              <strong className="text-slate-900">Droit d'accès :</strong> obtenir la confirmation
              que vos données sont traitées et en obtenir une copie
            </li>
            <li>
              <strong className="text-slate-900">Droit de rectification :</strong> demander la
              correction de données inexactes ou incomplètes
            </li>
            <li>
              <strong className="text-slate-900">Droit à l'effacement :</strong> demander la
              suppression de vos données dans les conditions prévues par le RGPD
            </li>
            <li>
              <strong className="text-slate-900">Droit à la portabilité :</strong> recevoir vos
              données dans un format structuré et lisible par machine
            </li>
            <li>
              <strong className="text-slate-900">Droit d'opposition :</strong> vous opposer au
              traitement de vos données pour des motifs légitimes
            </li>
            <li>
              <strong className="text-slate-900">Droit à la limitation :</strong> demander la
              limitation du traitement dans certaines circonstances
            </li>
            <li>
              <strong className="text-slate-900">Droit de retirer votre consentement :</strong>{' '}
              à tout moment, sans que cela ne compromette la licéité du traitement fondé sur le
              consentement effectué avant le retrait
            </li>
          </ul>
          <p className="mt-3 text-sm text-slate-600 leading-relaxed">
            Pour exercer vos droits, vous pouvez nous contacter à l'adresse suivante :{' '}
            <a href="mailto:dpo@afficheservices.fr" className="text-primary hover:underline">
              dpo@afficheservices.fr
            </a>
          </p>
          <p className="mt-3 text-sm text-slate-600 leading-relaxed">
            Nous nous engageons à répondre à votre demande dans un délai d'un mois à compter de sa
            réception. Vous disposez également du droit d'introduire une réclamation auprès de la
            Commission Nationale de l'Informatique et des Libertés (CNIL) :{' '}
            <a
              href="https://www.cnil.fr"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary hover:underline"
            >
              www.cnil.fr
            </a>
          </p>
        </div>

        {/* Cookies */}
        <div className="mt-10 border-t border-slate-100 pt-10">
          <h2 className="text-xl font-semibold text-slate-900">8. Cookies</h2>
          <p className="mt-3 text-sm text-slate-600 leading-relaxed">
            Le site afficheservices.fr utilise des cookies pour assurer son bon fonctionnement et
            améliorer l'expérience utilisateur. Un cookie est un petit fichier texte déposé sur
            votre terminal lors de la visite d'un site web.
          </p>
          <p className="mt-3 text-sm text-slate-600 leading-relaxed">
            Nous utilisons les catégories de cookies suivantes :
          </p>
          <ul className="mt-3 space-y-2 text-sm text-slate-600 leading-relaxed list-disc pl-5">
            <li>
              <strong className="text-slate-900">Cookies essentiels :</strong> nécessaires au
              fonctionnement du site (authentification, sécurité, préférences)
            </li>
            <li>
              <strong className="text-slate-900">Cookies analytiques :</strong> nous aident a
              comprendre comment les visiteurs utilisent le site (avec votre consentement)
            </li>
          </ul>
          <p className="mt-3 text-sm text-slate-600 leading-relaxed">
            Vous pouvez gerer vos préférences en matière de cookies à tout moment via le bandeau
            de gestion des cookies ou les paramètres de votre navigateur. Le refus des cookies non
            essentiels n'affecte pas la navigation sur le site.
          </p>
        </div>

        {/* Contact DPO */}
        <div className="mt-10 border-t border-slate-100 pt-10">
          <h2 className="text-xl font-semibold text-slate-900">9. Contact DPO</h2>
          <p className="mt-3 text-sm text-slate-600 leading-relaxed">
            Pour toute question relative à la protection de vos données personnelles ou pour exercer
            vos droits, vous pouvez contacter notre Délégué à la protection des données (DPO) :
          </p>
          <div className="mt-4 rounded-xl border border-slate-100 bg-slate-50 p-5">
            <p className="text-sm text-slate-600">
              <strong className="text-slate-900">Délégué à la protection des données</strong>
            </p>
            <p className="mt-1 text-sm text-slate-600">AfficheServices SAS</p>
            <p className="mt-1 text-sm text-slate-600">Paris, France</p>
            <p className="mt-1 text-sm text-slate-600">
              Email :{' '}
              <a href="mailto:dpo@afficheservices.fr" className="text-primary hover:underline">
                dpo@afficheservices.fr
              </a>
            </p>
          </div>
          <p className="mt-4 text-sm text-slate-600 leading-relaxed">
            Nous nous engageons à traiter toute demande avec diligence et dans le respect des délais
            prévus par la réglementation en vigueur. En cas de difficulté, vous pouvez également
            adresser une réclamation à la CNIL (Commission Nationale de l'Informatique et des
            Libertés), autorité de controle en matière de protection des données en France.
          </p>
        </div>
      </div>

      <Footer />
    </div>
  )
}
